<template>
  <div class="search-bar-container">
    <TextInput
      v-model="searchTerm"
      type="text"
      class="text-input"
      :is-validator-box-visible="false"
      @input="search"
    >
      <template #prefix>
        <span class="prefix-icon">
          <SvgIcon :data="require('@icons/streamline-icons/Outline version/01-Interface Essential/25-Search/search.svg')" />
        </span>
      </template>
      <template #suffix>
        <span
          v-if="searchTerm.length"
          class="suffix-icon"
          @click="clear"
        >
          <SvgIcon :data="require('@icons/streamline-icons/Outline version/01-Interface Essential/43-Remove-Add/remove.svg')" />
        </span>
      </template>
    </TextInput>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GetterTypes from '@/store/constants/getters';
import TextInput from '@/components/common/input/text-input/NorticTextInput.vue';

export default {
  name: 'OmniSearch',
  components: { TextInput },
  data() {
    return {
      searchTerm: '',
      results: {
        modules: [],
        events: [],
      },
    };
  },
  computed: {
    ...mapGetters([
      GetterTypes.GRANTED_SUB_MODULES,
      GetterTypes.CACHED_EVENTS,
      GetterTypes.OMNI_SEARCH_EVENT_BUS,
    ]),
    lowerCaseSearchTerm() {
      return this.searchTerm.toLocaleLowerCase();
    },
  },
  watch: {
    results: {
      deep: true,

      handler(newValue) {
        this.$emit('search-result-updated', newValue);
      },
    },
    searchTerm(newValue) {
      if (!newValue) {
        this.$emit('clear');
      }
    },
  },
  mounted() {
    this.omniSearchEventBus.on('clear', this.clear);
  },
  methods: {
    search() {
      if (this.searchTerm?.length >= 2) {
        this.searchForEvents();
        this.searchForModules();
      }
    },
    searchForModules() {
      this.results.modules = this[GetterTypes.GRANTED_SUB_MODULES]
        .filter((subModule) => this.searchByModuleName(subModule)
          || this.searchByTags(subModule));
    },
    searchForEvents() {
      this.results.events = this[GetterTypes.CACHED_EVENTS]
        .filter((event) => event.name?.toLowerCase().includes(this.lowerCaseSearchTerm));
    },
    searchByModuleName(subModule) {
      return subModule.moduleName.toLowerCase().includes(this.lowerCaseSearchTerm);
    },
    searchByTags(subModule) {
      return subModule.tags?.some((tag) => tag.toLowerCase().includes(this.lowerCaseSearchTerm));
    },
    clear() {
      this.searchTerm = '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .search-bar-container {
    padding: 0 17px;
    display: flex;
    align-items: center;

    .text-input {
      width: calc(100%);

      .prefix-icon {
        color: var(--primary-text-alt-color-hex);
        display: flex;
        font-size: 1.4em;
      }

      .suffix-icon {
        display: flex;
        cursor: pointer;
      }
    }
  }
</style>
